module.exports = __webpack_public_path__ + "media/images/athletes/2817-8196e5bf99655aea13bd39cf60788ab3.png";